//-----------------------------------
// scripts.js
// Author: @codymarcoux (Studio123)
//
// NOTE: Main scripts file
//-----------------------------------
$('button.open-row').on('click', function () {
  var buttonID = $(this).data('content');

  $(this).toggleClass('is-active');
  $(`.body.collapsible[data-content="${buttonID}"]`).toggleClass('is-active');
})